import { render, staticRenderFns } from "./BancolombiaQR.vue?vue&type=template&id=601cee46&scoped=true&"
import script from "./BancolombiaQR.vue?vue&type=script&lang=js&"
export * from "./BancolombiaQR.vue?vue&type=script&lang=js&"
import style0 from "./BancolombiaQR.vue?vue&type=style&index=0&id=601cee46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601cee46",
  null
  
)

export default component.exports